<template>
  <div class="search-customer">
    <search-customer-modal
      :show="showModal === 'customer-modal'"
      :is-purchase-order-customer-search="true"
      :disable-add-customer="disableAddCustomer"
      :page-type="pageTypes.PURCHASE_ORDER"
      @create-customer="createAndAddCustomer"
      @select-customer="selectCustomer"
      @close="showModal = false"
    />
    <search-company-modal
      :show="showModal === 'company-modal'"
      :page-type="pageTypes.PURCHASE_ORDER"
      @close="hideModalAndResetCompanies()"
    />

    <div v-if="showSearchCustomerBtn">
      <app-button data-qa="customer-search-button" @click="showModal = 'customer-modal'">
        {{ i18n.t('/KlantZoekenModal/ZoekKlant') }}
      </app-button>
    </div>
    <div v-if="showSearchCustomerCompanyBtn">
      <app-button data-qa="company-search-button" @click="addCompanyClick()">
        {{ i18n.t('/Company/AddCompany') }}
      </app-button>
    </div>
  </div>
</template>

<script>
import AppButton from '@/components/generic/presentational/atoms/appButton/AppButton.vue'
import SearchCustomerModal from '@/components/purchaseOrder/presentational/organisms/newCustomerSearch/SearchCustomerModal.vue'
import SearchCompanyModal from '@/components/generic/presentational/organisms/searchCompanyModal/SearchCompanyModal.vue'
import CustomerSearchHelper from '@/helpers/CustomerSearchHelper'
import CompaniesApi from 'api-client/Companies'
import { mapGetters } from 'vuex'
import CustomersApi from '@/api/server/Customers'
import { pageTypes } from '@/helpers/pageTypeConstants'

export default {
  components: {
    SearchCustomerModal,
    SearchCompanyModal,
    AppButton,
  },
  props: {
    translations: {
      type: Object,
      default: () => {},
    },
    disableAddCustomer: {
      type: Boolean,
      default: false,
    },
  },
  emits: ['selectCustomer'],
  data() {
    return {
      i18n: window.VUE_CLI_EXPORTS.plugins.i18n,
      showModal: false,
    }
  },
  computed: {
    ...mapGetters({
      purchaseCustomer: 'purchaseOrder/customer',
      purchaseCustomerCompany: 'purchaseOrder/customerCompany',
    }),
    pageTypes() {
      return pageTypes
    },
    showSearchCustomerBtn() {
      return (
        this.purchaseCustomer === null ||
        Object.values(this.purchaseCustomer).every((value) => value === null || value === false)
      )
    },
    showSearchCustomerCompanyBtn() {
      return (
        this.purchaseCustomerCompany === null ||
        Object.values(this.purchaseCustomerCompany).every(
          (value) => value === null || value === false
        )
      )
    },
  },
  methods: {
    async hideModalAndResetCompanies() {
      this.showModal = false
      this.$store.dispatch('companies/resetRecommendedCompany')
    },

    selectCustomer(customer) {
      if (customer.CustomerAddress !== null) {
        const parsedAddress = CustomerSearchHelper.parseAddress(customer.CustomerAddress)
        customer.CustomerStreet = parsedAddress.street
        customer.CustomerHouseNumber = parsedAddress.houseNumber
      }
      this.$emit('selectCustomer', customer)
    },
    async createAndAddCustomer(customer) {
      try {
        this.isSaving = true
        const newCustomer = await CustomersApi.createAccount(customer)
        this.$emit('selectCustomer', newCustomer)
        this.isSaving = false
      } catch (e) {
        EventBus.$emit('notification-warning', e.data.Messages)
      }
    },
    async addCompanyClick() {
      this.showModal = 'company-modal'

      await this.searchRecommendedCompany()
    },
    async searchRecommendedCompany() {
      const companyNumber = this.purchaseCustomer?.CustomerMagicNumber
      if (companyNumber == null) return

      const results = await CompaniesApi.searchCompany(companyNumber)

      if (results.length > 0) this.$store.dispatch('companies/setRecommendedCompany', results[0])
    },
  },
}
</script>
